export function productsMobileFilter() {
    App.D.on('click', '.js-mob-filter-checkbox', function() {
        let $filterItem = $(this);
        let $filterItemWrap = $filterItem.parents('.js-mob-filter-item');
        let $filterItemWrapCopy = $filterItemWrap.clone();
        let filterItemId = $filterItem.attr('id');

        if ($filterItem.is(':checked')) {
            $filterItemWrapCopy.find('.js-mob-filter-checkbox').attr('id', filterItemId + '-ch');
            $('.js-mob-filter-list').append($filterItemWrapCopy);
        } else {
            console.log($('.js-mob-filter-list').find('#' + filterItemId + '-ch').parents('.js-mob-filter-item'));
            $('.js-mob-filter-list').find('#' + filterItemId + '-ch').parents('.js-mob-filter-item').remove();
        }
    });

    App.D.on('click', '.js-mob-filter-clear', function() {
        $('.js-mob-filter-list').empty();
        $('.js-mob-filter-checkbox').prop( "checked", false );
    });
}

App.D.ready(function() {
    productsMobileFilter();
});